import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CheckIcon from '@material-ui/icons/Check';
import { getGlobalClasses } from '../../themes';
import GeoTabGroupConfigContainer from '../../containers/GeoTabGroupConfig';
import FormComponent from '../../components/FormComponent';

const styles = (theme) => ({
	...getGlobalClasses(theme),
	tableCard: {
		marginBottom: 32,
		overflowX: 'auto',
	},
	headerCell: {
		fontWeight: 700,
		backgroundColor: '#f5f5f5',
		whiteSpace: 'nowrap',
	},
	tableRow: {
		'&:nth-child(even)': {
			backgroundColor: '#fafafa',
		},
	},
	cell: {
		whiteSpace: 'nowrap',
		padding: '8px 16px',
	},
	checkCell: {
		whiteSpace: 'nowrap',
		padding: '8px 16px',
		textAlign: 'center',
	},
});

function CheckCell({ checked, classes }) {
	return <TableCell className={classes.checkCell}>{checked ? <CheckIcon /> : null}</TableCell>;
}

class GeoTabGroupConfig extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			geoTabGroupCollection: null,
			orderBy: 'groupName',
			order: 'asc',
		};
	}

	componentDidMount() {
		const { getGeoTabGroupCollection, showErrors } = this.props;
		getGeoTabGroupCollection({
			callback: (err, result) => {
				if (err) return showErrors(err);
				this.setState({ geoTabGroupCollection: result.geoTabGroupCollection });
			},
		});
	}

	handleSort = (column) => {
		const { orderBy, order } = this.state;
		const isAsc = orderBy === column && order === 'asc';
		this.setState({ orderBy: column, order: isAsc ? 'desc' : 'asc' });
	};

	render() {
		const { classes } = this.props;
		const { geoTabGroupCollection, orderBy, order } = this.state;

		const sortedGroupCollection = _.orderBy(geoTabGroupCollection || [], [orderBy], [order]);

		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>GeoTab Group Config</div>

				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Paper className={classes.tableCard}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell className={classes.headerCell}>GeoTab Group ID</TableCell>
										<TableCell className={classes.headerCell}>
											<TableSortLabel
												active={orderBy === 'groupName'}
												direction={orderBy === 'groupName' ? order : 'asc'}
												onClick={() => this.handleSort('groupName')}
											>
												Group Name
											</TableSortLabel>
										</TableCell>
										<TableCell className={classes.headerCell}>
											<TableSortLabel
												active={orderBy === 'isSuperior'}
												direction={orderBy === 'isSuperior' ? order : 'asc'}
												onClick={() => this.handleSort('isSuperior')}
											>
												Superior
											</TableSortLabel>
										</TableCell>
										<TableCell className={classes.headerCell}>
											<TableSortLabel
												active={orderBy === 'isWilliams'}
												direction={orderBy === 'isWilliams' ? order : 'asc'}
												onClick={() => this.handleSort('isWilliams')}
											>
												Williams
											</TableSortLabel>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{sortedGroupCollection.map((group) => (
										<TableRow key={group.geoTabGroupId} className={classes.tableRow}>
											<TableCell className={classes.cell}>{group.geoTabGroupId}</TableCell>
											<TableCell className={classes.cell}>{group.groupName}</TableCell>
											<CheckCell checked={group.isSuperior} classes={classes} />
											<CheckCell checked={group.isWilliams} classes={classes} />
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Paper>
					</Grid>
				</Grid>
			</Fragment>
		);
	}
}

GeoTabGroupConfig.propTypes = {
	classes: PropTypes.object.isRequired,
	getGeoTabGroupCollection: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), GeoTabGroupConfigContainer])(GeoTabGroupConfig);
